import { createFileRoute } from "@tanstack/react-router";

import { DepartmentsIndexPage, departmentsIndexHead } from "../components/prenoms/department-pages";
import { namesApi } from "../lib/api";
import { seo } from "../lib/head";

export const Route = createFileRoute("/prenoms/departement/")({
  staticData: { ssr: true },
  loader: ({ context }) =>
    context.queryClient.query({
      queryKey: ["prenoms-departments"],
      queryFn: namesApi.departments,
      staleTime: "static",
    }),
  head: () => seo(departmentsIndexHead()),
  component: Page,
});
function Page() {
  return <DepartmentsIndexPage departments={Route.useLoaderData()} />;
}
